let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iOb7n")).then(() => parcelRequire('6DKkq'));